import axios from 'axios';

let user = {
  access_token: ''
};

try {
  user = JSON.parse(localStorage.getItem('user')) || { access_token: '' };
} catch (error) {
  // eslint-disable-next-line
}

const instance = axios.create({
  headers: {
    Authorization: `Bearer ${user.access_token}`
  }
});

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 403 || error.response.status === 401) {
      window.location.href = '/pages/login';
    }

    return Promise.reject(error);
  }
);

export default instance;
